import Vue from 'vue'

export function getErrorMessage (eres) {
  if (eres.response.status == 404) {
    return "Router " + eres.response.statusText;
  }
  return eres.response.data.user_message
}

export function successMessage (msg) {
  Vue.toasted.success(msg).goAway(2000)
}

export function showErrorMessage (eres) {
  if (!eres.response) {
    console.log(eres, 'exception tanpa status')
    return;
  }
  if (eres.response.status == 404) {
    const msg = "Router " + eres.response.statusText
    Vue.toasted.error(msg).goAway(2000)
    return []
  }
  if (eres.response.status == 500) {
    const msg = eres.response.statusText + ` [${eres.response.data.user_message}]`
    Vue.toasted.error(msg).goAway(2000)
    return []
  }
  if (eres.response.status == 422) {
    if (eres.response.data.errors) {
      Vue.toasted.error(eres.response.data.user_message).goAway(2000)
      return eres.response.data.errors;
    }
    if (eres.response.data.user_message) {
      Vue.toasted.error(eres.response.data.user_message).goAway(2000)
      if (eres.response.data.errors) {
        return eres.response.data.errors
      }
      return []
    }
    const msg = eres.response.statusText
    Vue.toasted.error(msg).goAway(2000)
    return eres.response.data
  }
  return eres.response.data
}

export function convertObjToString (obj) {
  var str = "";
  for (var key in obj) {
    if (str != "") {
      str += "&";
    }
    str += key + "=" + obj[key];
  }
  return str
}
